import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Select from "react-select";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Papa from "papaparse";
import { login } from "../../auth/msalAuth"
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import {
  DialogTitle,
  TextField
} from "@mui/material";

import "./accordion.scss";
import protocolStructure from "./protocolStructe";
import {
  Box,
  CircularProgress,
  IconButton,
  Modal,
  Snackbar,
  Dialog,
  DialogActions,
  DialogContent,
  Alert,
} from "@mui/material";
import { useState, useMemo } from "react";
import { useEffect } from "react";
import { getToken } from "../../auth/authConfig";
import axios from "axios";
import { useSetRecoilState } from "recoil";
import {
  auditSwitchType,
  protocolType,
  switchProtocolType,
} from "../../../store/audit details/atom";
import { Button } from "react-bootstrap";
import { IoTrashOutline } from "react-icons/io5";
import LeadAuditOtherProtocolExcel from "../../reusables/LeadAuditOtherProtocolExcel";
import { CheckCircle2, AlertCircle } from "lucide-react";

const adendumDropdown = {
  standardOrTechnical: [
    {
      value: "option",
      label: "option",
    },
  ],
  requirementReference: [
    {
      value: "option",
      label: "option",
    },
  ],
  nonconformity: [
    {
      value: "Critical",
      label: "Critical",
    },
    {
      value: "Major",
      label: "Major",
    },
    {
      value: "Minor",
      label: "Minor",
    },
    {
      value: "Opportunity for Improvement (OFI)",
      label: "Opportunity for Improvement (OFI)",
    },
  ],
  nonconformance: [
    {
      value: "Open",
      label: "Open",
    },
    {
      value: "Closed",
      label: "Closed",
    },
    {
      value: "New",
      label: "New",
    },
  ],
};

const tableHeaderOrder = [
  "Number (#)",
  "Standard or Technical Specifications",
  "Requirement Reference",
  "Details of Nonconformity",
  "Evidence of Non-conformity",
  "Nonconformity Rating",
  "NonConformance Status",
];

const previousYearTableHeaders = [
  "Number (#)",
  "Standard or Technical Specifications",
  "Requirement Reference",
  "Details of Nonconformity",
  "Evidence of Non-conformity",
  "Nonconformity Rating",
  "NonConformance Status",
  "Evidence Of Correction"

]

// const tableHeaderOrder = [
//   "Number (#)",
//   "Standard or Technical Specifications",
//   "Requirement Reference",
//   "Nonconformity Rating",
//   "Details of Nonconformity",
//   "Evidence of Non-conformity",
//   "NonConformance Status",
// ];

const GapAssesmentAccordion = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const auditNumber = queryParams.get("auditNumber");
  const [fileName, setFileName] = useState("No File Chosen");
  const [activity, setActivity] = useState("saved");
  const [csvData, setCsvData] = useState([]);
  const [focusAreaField, setFocusAreaField] = useState([]);
  const [previousFfsc, setPreviousFfsc] = useState([])
  const [formData, setFormData] = useState({
    formId: auditNumber,
    areasOfConcern: [],
    ffscFindings: [],
    activity: activity,
    focusArea: {},
    protocolList: {
      protocolFindings: [],
      sections: []
    }
  });

  const [standardOptions, setStandardOPtions] = useState([]);
  const [requirementOptions, setRequirementOptions] = useState([]);
  const [submitDisable, setSubmitDisable] = useState(false);
  const [siteCode, setSiteCode] = useState("");
  const [year, setYear] = useState("");
  const setProtocolType = useSetRecoilState(protocolType);
  const setSwitchType = useSetRecoilState(auditSwitchType);
  const storeProtocolType = useSetRecoilState(switchProtocolType);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState({
    save: false,
    submit: false,
  });
  const [open, setOpen] = useState(false);
  const [auditPageData, setAuditPageData] = useState({});
  const [auditAndProtocolData, setAuditAndProtocolData] = useState({});
  const [attendiesInArrayFormat, setAttendiesInArrayFormat] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [unitDetails, setUnitDetails] = useState([]);
  const [unitIndex, setUnitIndex] = useState("");
  const [openExpand, setOpenExpand] = useState(false);
  const [lastValue, setLastValue] = useState("");
  const [lastIndex, setLastIndex] = useState("");
  const [originalValue, setOriginalValue] = useState(""); // Store the original value
  const [error, setError] = useState(false);
  const [openFFscExpand, setFFscExpand] = useState(false)
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState("");

  // Progress tracking and section overview logic
  const [expandedSections, setExpandedSections] = useState({});
  const [completedQuestions, setCompletedQuestions] = useState(new Set());

  // Get section names dynamically
  const sectionNames = useMemo(() => {
    const sections = [];

    // Add protocol sections
    if (formData?.protocolList?.protocolFindings) {
      formData.protocolList.protocolFindings.forEach(section => {
        sections.push(section.section);
      });
    }

    // Add other sections
    if (focusAreaField.length > 0) {
      sections.push("Focus Areas - Special Attention");
    }
    sections.push("Areas of Concern- Findings Log");
    // Removed FSSC Findings from progress tracking

    return sections;
  }, [formData, focusAreaField]);

  // Get all required question IDs
  const requiredQuestions = useMemo(() => {
    const required = new Set();

    // Protocol questions
    if (formData?.protocolList?.protocolFindings) {
      formData.protocolList.protocolFindings.forEach(section => {
        section.subsection.forEach(subsection => {
          subsection.questions.forEach(question => {
            if (question.is_required) {
              required.add(question.question_id);
            }
          });
        });
      });
    }

    // Focus area fields
    if (formData?.focusArea) {
      Object.keys(formData.focusArea).forEach(key => {
        required.add(`focusArea_${key}`);
      });
    }

    // Areas of concern (at least one complete entry)
    if (formData?.areasOfConcern?.length > 0) {
      const currentYearAreas = formData.areasOfConcern.filter(area => !area.isPreviousYear);
      if (currentYearAreas.length > 0) {
        required.add('areasOfConcern_complete');
      }
    }

    return required;
  }, [formData]);

  // Check if all required fields are filled
  const isFormValid = useMemo(() => {
    return Array.from(requiredQuestions).every(questionId => {
      // Ensure questionId is a string before using string methods
      const questionIdStr = String(questionId);

      if (questionIdStr.startsWith('focusArea_')) {
        const key = questionIdStr.replace('focusArea_', '');
        return formData?.focusArea?.[key] && formData.focusArea[key].trim().length > 0;
      }

      if (questionIdStr === 'areasOfConcern_complete') {
        const currentYearAreas = formData?.areasOfConcern?.filter(area => !area.isPreviousYear) || [];
        return currentYearAreas.length > 0 && currentYearAreas.every(area =>
          area.number &&
          area.standardOrTechnicalSpecification &&
          area.RequirementReference &&
          area.detailsOfNonconformity &&
          area.evidenceOfNonconformity &&
          area.nonconformityRating &&
          area.nonConformanceStatus
        );
      }

      // Protocol questions
      if (formData?.protocolList?.protocolFindings) {
        for (const section of formData.protocolList.protocolFindings) {
          for (const subsection of section.subsection) {
            for (const question of subsection.questions) {
              if (question.question_id === questionId) {
                return question.answer && question.answer.trim().length > 0;
              }
            }
          }
        }
      }

      return false;
    });
  }, [requiredQuestions, formData]);

  // Get total question count
  const totalQuestions = useMemo(() => {
    let count = 0;

    // Protocol questions
    if (formData?.protocolList?.protocolFindings) {
      formData.protocolList.protocolFindings.forEach(section => {
        section.subsection.forEach(subsection => {
          count += subsection.questions.length;
        });
      });
    }

    // Focus area fields
    if (formData?.focusArea) {
      count += Object.keys(formData.focusArea).length;
    }

    // Areas of concern (count as one question per complete entry)
    const currentYearAreas = formData?.areasOfConcern?.filter(area => !area.isPreviousYear) || [];
    count += currentYearAreas.length;

    return count;
  }, [formData]);

  // Get section statistics
  const sectionStats = useMemo(() => {
    const stats = {};

    // Protocol sections
    if (formData?.protocolList?.protocolFindings) {
      formData.protocolList.protocolFindings.forEach(section => {
        const sectionName = section.section;
        let total = 0;
        let completed = 0;
        let required = 0;
        let requiredCompleted = 0;

        section.subsection.forEach(subsection => {
          subsection.questions.forEach(question => {
            total++;
            if (question.answer && question.answer.trim()) {
              completed++;
            }
            if (question.is_required) {
              required++;
              if (question.answer && question.answer.trim()) {
                requiredCompleted++;
              }
            }
          });
        });

        stats[sectionName] = { total, completed, required, requiredCompleted };
      });
    }

    // Focus Areas section
    if (focusAreaField.length > 0) {
      const focusAreaName = "Focus Areas - Special Attention";
      const total = Object.keys(formData?.focusArea || {}).length;
      const completed = Object.values(formData?.focusArea || {}).filter(value => value && value.trim()).length;
      const required = total;
      const requiredCompleted = completed;

      stats[focusAreaName] = { total, completed, required, requiredCompleted };
    }

    // Areas of Concern section
    const areasOfConcernName = "Areas of Concern- Findings Log";
    const currentYearAreas = formData?.areasOfConcern?.filter(area => !area.isPreviousYear) || [];
    const total = currentYearAreas.length;
    const completed = currentYearAreas.filter(area =>
      area.number &&
      area.standardOrTechnicalSpecification &&
      area.RequirementReference &&
      area.detailsOfNonconformity &&
      area.evidenceOfNonconformity &&
      area.nonconformityRating &&
      area.nonConformanceStatus
    ).length;
    const required = total > 0 ? 1 : 0; // At least one complete entry
    const requiredCompleted = completed > 0 ? 1 : 0;

    stats[areasOfConcernName] = { total, completed, required, requiredCompleted };

    // Removed FSSC Findings section from progress tracking

    return stats;
  }, [formData, focusAreaField]);

  console.log("formData", formData)



  const currentYearItems = formData?.areasOfConcern
    ?.map((item, originalIndex) => ({ item, originalIndex }))
    ?.filter(({ item }) => item?.isPreviousYear === false);

  const previousYearItems = formData?.areasOfConcern
    ?.map((item, originalIndex) => ({ item, originalIndex }))
    ?.filter(({ item }) => item?.isPreviousYear === true);

  const currentYearFfsc = formData?.ffscFindings
    ?.map((item, originalIndex) => ({ item, originalIndex }))
    ?.filter(({ item }) => item["Is Previous Year"] === false);


  const previousYearFfsc = formData?.ffscFindings
    ?.map((item, originalIndex) => ({ item, originalIndex }))
    ?.filter(({ item }) => item["Is Previous Year"] === true);

  const handleExpand = (index, value) => {
    // alert("this is working")
    setLastIndex(index)
    setLastValue(value)
    setOriginalValue(value) // Store the original value
    setOpenExpand(true);

  }

  const handleFfscExpand = (index, value) => {
    // alert("this is working")
    setLastIndex(index)
    setLastValue(value)
    setOriginalValue(value) // Store the original value
    setFFscExpand(true);
  }
  const handleExpandClose = () => {
    setOpenExpand(false)
    setFFscExpand(false)
  }

  // Progress tracking helper functions
  const toggleSection = (sectionName) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionName]: !prev[sectionName]
    }));
  };

  const getSectionColor = (index) => {
    const colors = [
      'bg-teal-50 border-teal-200',
      'bg-blue-50 border-blue-200',
      'bg-indigo-50 border-indigo-200',
      'bg-purple-50 border-purple-200',
      'bg-green-50 border-green-200',
      'bg-orange-50 border-orange-200'
    ];
    return colors[index % colors.length];
  };

  const getHeaderColor = (index) => {
    const colors = [
      'bg-teal-500',
      'bg-teal-500',
      'bg-teal-500',
      'bg-teal-500',
      'bg-teal-500',
      'bg-teal-500'
    ];
    return colors[index % colors.length];
  };

  const getProgressColor = (completed, total) => {
    if (total <= 0) return "text-green-600"; // or whatever default you want

    const percentage = total >= 0 ? (completed / total) * 100 : 0;
    console.log("percentage", percentage)
    console.log("completed", completed)
    console.log("total", total)

    if (percentage === 100) return 'text-green-600';
    if (percentage >= 50) return 'text-yellow-600';
    return 'text-red-600';
  };

  const getCompletedQuestionsCount = () => {
    let count = 0;

    // Protocol questions
    if (formData?.protocolList?.protocolFindings) {
      formData.protocolList.protocolFindings.forEach(section => {
        section.subsection.forEach(subsection => {
          subsection.questions.forEach(question => {
            if (question.answer && question.answer.trim()) {
              count++;
            }
          });
        });
      });
    }

    // Focus area fields
    if (formData?.focusArea) {
      Object.values(formData.focusArea).forEach(value => {
        if (value && value.trim()) {
          count++;
        }
      });
    }

    // Areas of concern (count complete entries)
    const currentYearAreas = formData?.areasOfConcern?.filter(area => !area.isPreviousYear) || [];
    count += currentYearAreas.filter(area =>
      area.number &&
      area.standardOrTechnicalSpecification &&
      area.RequirementReference &&
      area.detailsOfNonconformity &&
      area.evidenceOfNonconformity &&
      area.nonconformityRating &&
      area.nonConformanceStatus
    ).length;

    return count;
  };

  const handleSave = () => {
    // Save the current value from the dialog based on which dialog is open
    if (openExpand) {
      handleAreaOfConcernChange(lastIndex, "evidenceOfCorrection", lastValue)
    } else if (openFFscExpand) {
      handleFfscChange(lastIndex, "Evidence Of Correction", lastValue)
    }
    setOpenExpand(false)
    setFFscExpand(false)
  }

  const handleCancel = () => {
    // Restore the original value and close the dialog
    setLastValue(originalValue) // Restore the original value
    setOpenExpand(false)
    setFFscExpand(false)
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleErrorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setErrorSnackbarOpen(false);
  };
  const [snackbarMessage, setSnackbarMessage] = useState("");
  // console.log("requirementOptions",requirementOptions)

  const uploadFileHandler = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      parseCSV(file);
      // Clear the file input value so the same file can be selected again
      e.target.value = '';
    }
  };
  const handleInputChange = (name, value, item) => {
    if (name === "focusArea") {
      setFormData((prevData) => ({
        ...prevData,
        focusArea: {
          ...prevData.focusArea, // Keep existing focusArea data
          [item]: value, // Update the correct field inside focusArea
        },
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleQuestionAnswerChange = (sectionIndex, subsectionIndex, questionIndex, value) => {
    setFormData((prevData) => {
      const updatedProtocolFindings = [...prevData.protocolList.protocolFindings];
      updatedProtocolFindings[sectionIndex].subsection[subsectionIndex].questions[questionIndex].answer = value;

      return {
        ...prevData,
        protocolList: {
          ...prevData.protocolList,
          protocolFindings: updatedProtocolFindings
        }
      };
    });
  };

  const handleAreaOfConcernChange = (index, field, value) => {
    // const value = selectedOption ? selectedOption.value : selectedOption; // Extract value from selected option
    const newValue =
      field.includes("detailsOfNonconformity") ||
        field.includes("evidenceOfNonconformity") ||
        field.includes("evidenceOfCorrection")
        ? value // Just set the value directly for text fields
        : value?.value;
    setFormData((prevData) => ({
      ...prevData,
      areasOfConcern: prevData.areasOfConcern.map((item, i) => {
        if (i === index) {
          return { ...item, [field]: newValue }; // Update the correct field
        }
        return item;
      }),
    }));
  };

  const handleFfscChange = (index, field, value) => {
    console.log("entering value", value)
    console.log("field", field)
    const newValue =
      // field.includes("NonConformance Status") ||
      // field.includes("Nonconformity Rating") ||
      field.includes("Evidence Of Correction")
        ? value // Just set the value directly for text fields
        : value?.value;
    setFormData((prevData) => ({
      ...prevData,
      ffscFindings: prevData.ffscFindings.map((item, i) => {
        if (i === index) {
          console.log("index", index)
          return { ...item, [field]: newValue }; // Update the correct field
        }
        return item;
      }),
    }));
  }

  // const parseCSV = (file) => {
  //   Papa.parse(file, {
  //     complete: (result) => {
  //       // The result.data now contains an array of objects with the proper column names as keys
  //       const rows = result.data.slice(0, 35); // Limit to 30 rows
  //       setCsvData(rows);
  //     },
  //     header: true, // This ensures the first row is treated as the header
  //     skipEmptyLines: true,
  //   });
  // };

  const parseCSV = (file) => {
    Papa.parse(file, {
      complete: (result) => {
        const transformedData = result.data
          .slice(0, 35) // limit rows
          .map((row) => {
            const transformedRow = { ...row };

            // Rename "Non-Conformance Status" to "NonConformance Status"
            if ('Non-Conformance Status' in transformedRow) {
              transformedRow['NonConformance Status'] = transformedRow['Non-Conformance Status'];
              delete transformedRow['Non-Conformance Status'];
            }

            // Add isPreviousYear: false
            transformedRow["Is Previous Year"] = false;

            return transformedRow;
          });

        setCsvData(transformedData);
      },
      header: true,
      skipEmptyLines: true,
    });
  };

  const submitGapAssesmentForm = async (check) => {
    try {
      // setloading(true);
      if (check === "saved") {
        //  setActivity(check);
        setSnackbarMessage("Form Saved Successfully!");
        setActionLoading((prev) => ({
          ...prev,
          save: true,
        }));
      }
      if (check === "completed") {
        //  setActivity(check);
        setSnackbarMessage("Form Submitted Successfully!");
        setActionLoading((prev) => ({
          ...prev,
          submit: true,
        }));
      }
      const url = `${process.env.REACT_APP_SERVER_URL}/api/protocol/gap_assessment_save`;
      const token = await getToken();

      // Transform protocol data to question_id: answer format
      const protocolAnswers = {};
      if (formData.protocolList && formData.protocolList.protocolFindings) {
        formData.protocolList.protocolFindings.forEach((section) => {
          section.subsection.forEach((subsection) => {
            subsection.questions.forEach((question) => {
              protocolAnswers[question.question_id] = question.answer;
            });
          });
        });
      }

      // Filter out old hardcoded fields and only send necessary data
      const {
        scopingObjective,
        scopingKeyAuditPoints,
        leadershipObjective,
        leadershipMarsQualityPolicy,
        leadershipAccountabilities,
        leadershipQMSObjective,
        leadershipEngagement,
        planObjective,
        planQualityObjectives,
        planProcessIdentification,
        planQualityRiskManagement,
        planChangeManagement,
        planMergers,
        planResources,
        doObjective,
        doInnovation,
        doCreationOfProducts,
        doIdentification,
        doControl,
        doPurchasing,
        doConsumer,
        doOrganizationalDesign,
        doOrganizationalKnowledge,
        doCommunication,
        doWorkEnvironment,
        doCalibration,
        checkObjective,
        checkAudit,
        checkCustomer,
        checkKeyPerformance,
        checkMarsQmsReview,
        actObjective,
        actImprovement,
        actEffectiveness,
        specificRequirementGovernance,
        protocolList, // Remove the nested protocolList since we're flattening it
        ...cleanFormData
      } = formData;

      let payload = {
        ...cleanFormData, // Only send the clean data without hardcoded fields
        protocolFindings: protocolAnswers, // Add the question_id: answer mappings
        activity: check
      };

      const response = await axios.post(url, payload, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 201) {
        const json = response.data;
        setOpen(true);
        if (check === "saved") {
          setActionLoading((prev) => ({
            ...prev,
            save: false,
          }));
        }
        if (check === "completed") {
          setActionLoading((prev) => ({
            ...prev,
            submit: false,
          }));
          // navigate here for scoring
          setProtocolType("scoringDetails");
          storeProtocolType("Gap Assessment");
          setSwitchType("");
        }
      }
    } catch (e) {
      if (check === "saved") {
        setActionLoading((prev) => ({
          ...prev,
          save: false,
        }));
      }
      if (check === "completed") {
        setActionLoading((prev) => ({
          ...prev,
          submit: false,
        }));
      }
      const status = e?.response?.status;
      if (status === 401) {
        login();
      } else {
        // Extract error message from response
        const errorMessage = e?.response?.data?.error || "Something went wrong! Please try again later.";
        setErrorSnackbarMessage(errorMessage);
        setErrorSnackbarOpen(true);

        // Auto-hide error snackbar after 5 seconds
        setTimeout(() => {
          setErrorSnackbarOpen(false);
        }, 5000);
      }
      console.error("Error while calling the API:", e);
      // setloading(false);
    }
  };

  const getFocusAreaFields = async () => {
    try {
      // setloading(true);

      const url = `${process.env.REACT_APP_SERVER_URL}/api/forms/get_audit/${auditNumber}`;
      const token = await getToken();

      const response = await axios.get(url, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        const json = response.data;
        if (json?.audit_focus_area) {
          setFocusAreaField(json.audit_focus_area);

          const focusAreas = Array.isArray(json.audit_focus_area)
            ? json.audit_focus_area
            : [];

          if (focusAreas.length > 0) {
            // Debugging with console.log
            // console.log("Focus Areas:", focusAreas);

            const newFocusAreas = {};
            focusAreas.forEach((area) => {
              newFocusAreas[area] = ""; // Default value for each focus area
            });

            // Update formData with the new focus areas
            setFormData((prevState) => ({
              ...prevState,
              focusArea: newFocusAreas,
            }));
          }
        }
        if (json) {
          setAuditPageData(json);
        }
      }
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        login();
      } else {
        // Extract error message from response
        const errorMessage = e?.response?.data?.error || "Something went wrong! Please try again later.";
        setErrorSnackbarMessage(errorMessage);
        setErrorSnackbarOpen(true);

        // Auto-hide error snackbar after 5 seconds
        setTimeout(() => {
          setErrorSnackbarOpen(false);
        }, 5000);
      }
      console.error("Error while calling the API:", e);
      // setloading(false);
    }
  };

  // console.log("current form data", formData)

  const getFormData = async () => {
    try {
      // setloading(true);

      if (auditNumber) {
        const url = `${process.env.REACT_APP_SERVER_URL}/api/protocol/get_gap_assessment/${auditNumber}`;
        const token = await getToken();

        const response = await axios.get(url, {
          headers: {
            "oidc-token": token,
            Accept: "application/json",
          },
        });

        if (response.status === 200) {
          const json = response.data;

          if (json?.technicalCriteria) {
            setStandardOPtions(json?.technicalCriteria);
          }

          if (json?.unitIndexCode) {
            setSiteCode(json.unitIndexCode);
          }
          if (json?.year) {
            setYear(json.year);
          }

          if (json) {
            setPreviousFfsc(json?.ffscFindings)

            setLoading(false);
            const checkAreaOfConc =
              json && json.areasOfConcern && json.areasOfConcern.length >= 0;

            if (checkAreaOfConc) {
              setFormData((prevFormData) => ({
                ...prevFormData, // Keep all existing form data
                ...json, // Replace with response data
                areasOfConcern:
                  json.areasOfConcern || prevFormData.areasOfConcern, // Replace if exists, else keep previous
                ffscFindings: json.ffscFindings || prevFormData.ffscFindings, // Same logic for ffscFindings
                activity: json.activity || prevFormData.activity, // Same logic for activity
                focusArea: (json.focusArea && Object.keys(json.focusArea).length > 0) ? json.focusArea : prevFormData.focusArea, // Same logic for focusArea
                technicalCriteria:
                  json.technicalCriteria || prevFormData.technicalCriteria, // Same logic for technicalCriteria
                formId: json.formId || prevFormData.formId, // Replace formId with the one from the API
                unitIndexCode: json.unitIndexCode || prevFormData.unitIndexCode, // Replace unitIndexCode if present
                year: json.year || prevFormData.year, // Replace year if present
                protocolList: json.protocolList || prevFormData.protocolList,
                // protocolList: protocolStructure // Use protocolStructure for now
              }));
            }

            if (checkAreaOfConc) {
              json.areasOfConcern.forEach((element, index) => {
                if (
                  element?.requirementOptions &&
                  element?.requirementOptions.length > 0
                ) {
                  const formattedRequirementOption =
                    element?.requirementOptions.map((item) => ({
                      label: item,
                      value: item,
                    }));
                  setRequirementOptions((prev) => {
                    const updatedOptions = [...prev];
                    updatedOptions[index] = formattedRequirementOption;
                    return updatedOptions;
                  });
                }
              });
            }
          }
        }
      }
    } catch (e) {
      setLoading(false);
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      console.error("Error while calling the API:", e);
      // setloading(false);
    }
  };
  const unitDetailsInfo = async () => {
    const viewUrl = `${process.env.REACT_APP_SERVER_URL}/super/view_forms/${auditNumber}`;
    const token = await getToken();
    try {
      setLoading(true);
      const response = await axios.get(viewUrl, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });
      if (response.status === 200) {
        const data = response.data;
        const unit_index = data?.unitIndex;
        const combinedData = [
          ...data.unitDetails.unitDetails,
          ...data.unitDetails.offSiteFields
        ]
        if (combinedData) {
          setUnitDetails(combinedData)
        }
        if (unit_index) {
          setUnitIndex(unit_index)
        }

        console.log("combine data", combinedData)


      }
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        login();
      } else {
        // Extract error message from response
        const errorMessage = e?.response?.data?.error || "Something went wrong! Please try again later.";
        setErrorSnackbarMessage(errorMessage);
        setErrorSnackbarOpen(true);

        // Auto-hide error snackbar after 5 seconds
        setTimeout(() => {
          setErrorSnackbarOpen(false);
        }, 5000);
      }

      console.log("getting error while calling the api");
    }
  };

  const getRequirementReferenceOptions = async (value, index) => {
    // // console.log("getting value", value)
    try {
      if (value) {
        // setLoading(true)
        const url = `${process.env.REACT_APP_SERVER_URL}/api/audit/get_requirement`;
        // http://127.0.0.1:5000//api/audit/get_requirement?technicalStandard=ISO
        const token = await getToken();
        const body = {
          technicalStandard: value,
        };
        const response = await axios.post(url, body, {
          headers: {
            "oidc-token": token,
            Accept: "application/json",
          },
        });

        if (response.status === 200) {
          const json = response.data;
          // setLoading(false);
          if (json && json?.requirements) {
            const formattedRequirementOption =
              json?.requirements &&
              json.requirements.map((item) => ({
                label: item,
                value: item,
              }));
            setRequirementOptions((prev) => {
              const updatedOptions = [...prev]; // Create a copy of the previous state
              updatedOptions[index] = formattedRequirementOption; // Insert the formatted options at the specified index
              return updatedOptions;
            });
          }
        }
      }
    } catch (e) {
      setLoading(false);
      const status = e?.response?.status;
      if (status === 401) {
        login();
      } else {
        // Extract error message from response
        const errorMessage = e?.response?.data?.error || "Something went wrong! Please try again later.";
        setErrorSnackbarMessage(errorMessage);
        setErrorSnackbarOpen(true);

        // Auto-hide error snackbar after 5 seconds
        setTimeout(() => {
          setErrorSnackbarOpen(false);
        }, 5000);
      }
      console.error("Error while calling the API:", e);
      // setloading(false);
    }
  };

  // // console.log("here is csv data", csvData);
  let tableHeader;
  if (formData?.ffscFindings.length > 0) {
    tableHeader = Object.keys(formData.ffscFindings[0]);
    // console.log("tableheader", tableHeader);
  }

  // const addNewAreasOfConcern = () => {
  //   // Check if the number of areas of concern exceeds the limit
  //   if (formData?.areasOfConcern?.length >= 35) {
  //     alert("You can only add up to 35 more areas of concern.");
  //     return; // Prevent adding more rows
  //   }

  //   // Only proceed if there is at least one area of concern
  //   if (formData?.areasOfConcern?.length >= 0) {
  //     const lastArea =
  //       formData.areasOfConcern[formData.areasOfConcern.length - 1];

  //     // Extract the last part of the number (e.g., "0001" from "2025-474-0001")
  //     const lastNumber = lastArea?.number || `${year}-${siteCode}-0000`; // Default to a valid number if no areas of concern
  //     const lastDigitsMatch = lastNumber.match(/(\d{4})$/);

  //     if (lastDigitsMatch) {
  //       // Extract the last 4 digits and increment them
  //       const lastFourDigits = parseInt(lastDigitsMatch[0]);
  //       const newLastFourDigits = String(lastFourDigits + 1).padStart(4, "0"); // Ensure it's 4 digits long

  //       // Construct the new number (same format as the last one)
  //       const newNumber = `${lastNumber.slice(
  //         0,
  //         lastNumber.length - 4
  //       )}${newLastFourDigits}`;

  //       // Create the new area of concern
  //       const newAreaOfConcern = {
  //         number: newNumber,
  //         standardOrTechnicalSpecification: "",
  //         RequirementReference: "",
  //         detailsOfNonconformity: "",
  //         evidenceOfNonconformity: "",
  //         nonconformityRating: "",
  //         nonConformanceStatus: "",
  //       };

  //       // Update the formData by adding the new area of concern
  //       setFormData((prevFormData) => ({
  //         ...prevFormData,
  //         areasOfConcern: [...prevFormData.areasOfConcern, newAreaOfConcern],
  //       }));
  //     }
  //   }
  // };
  const addNewAreasOfConcern = () => {

    // Filter out previous year entries

    const currentYearAreas = formData?.areasOfConcern?.filter(

      (area) => area.isPreviousYear === false

    ) || [];

    // Check if the number of current-year areas exceeds the limit

    if (currentYearAreas.length >= 35) {

      alert("You can only add up to 35 areas of concern for the current year.");

      return;

    }

    // Proceed to add if list is valid

    const lastArea = currentYearAreas[currentYearAreas.length - 1];

    // Use a default starting number if no current-year areas exist

    const lastNumber = lastArea?.number || `${year}-${siteCode}-0000`;

    const lastDigitsMatch = lastNumber.match(/(\d{4})$/);

    if (lastDigitsMatch) {

      const lastFourDigits = parseInt(lastDigitsMatch[0]);

      const newLastFourDigits = String(lastFourDigits + 1).padStart(4, "0");

      const newNumber = `${lastNumber.slice(0, lastNumber.length - 4)}${newLastFourDigits}`;

      const newAreaOfConcern = {

        number: newNumber,

        standardOrTechnicalSpecification: "",

        RequirementReference: "",

        detailsOfNonconformity: "",

        evidenceOfNonconformity: "",

        nonconformityRating: "",

        nonConformanceStatus: "",

        isPreviousYear: false, // explicitly mark new entries as current year,
        evidenceOfCorrection: null

      };

      setFormData((prevFormData) => ({

        ...prevFormData,

        areasOfConcern: [...prevFormData.areasOfConcern, newAreaOfConcern],

      }));

    }

  };

  const removeAreas = (index) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      areasOfConcern: prevFormData.areasOfConcern.filter((_, i) => i !== index),
    }));
  };

  const standardOptionsFormat =
    standardOptions &&
    standardOptions.map((item) => ({
      label: item,
      value: item,
    }));

  // Function to check if all fields are filled
  const checkFormCompletion = (formData) => {
    // Check protocol questions
    if (formData?.protocolList?.protocolFindings) {
      for (const section of formData.protocolList.protocolFindings) {
        for (const subsection of section.subsection) {
          for (const question of subsection.questions) {
            if (question.is_required && (!question.answer || question.answer.trim() === "")) {
              return false;
            }
          }
        }
      }
    }

    // Check areasOfConcern
    for (const concern of formData.areasOfConcern) {
      const concernFields = [
        concern.number,
        concern.standardOrTechnicalSpecification,
        concern.RequirementReference,
        concern.detailsOfNonconformity,
        concern.evidenceOfNonconformity,
        concern.nonconformityRating,
        concern.nonConformanceStatus,
      ];

      for (const field of concernFields) {
        if (!field || field === "") {
          return false; // If any field is empty in areasOfConcern, return false
        }
      }
    }

    return true; // All fields are filled
  };

  function toggleSubmitButton() {
    // const submitButton = document.getElementById("submitButton");
    if (checkFormCompletion(formData)) {
      // submitButton.disabled = false;  // Enable button if all fields are filled
      setSubmitDisable(true);
    } else {
      // submitButton.disabled = true;  // Disable button if any field is empty
      setSubmitDisable(false);
    }
  }

  function checkFocusAreaValues(formData) {
    const focusArea = formData.focusArea;

    // Loop through all keys in focusArea and check if any value is empty
    for (let key in focusArea) {
      if (focusArea[key] === "") {
        return false; // If any value is empty, return false
      }
    }

    return true; // If all values are non-empty, return true
  }

  // Check if all values in focusArea are filled
  const isFocusAreaValid = checkFocusAreaValues(formData);

  useEffect(() => {
    toggleSubmitButton();
  }, [formData]);

  useEffect(() => {

    const prevData = previousYearFfsc?.map(entry => entry.item) || [];

    const updatedFFsc = [...prevData, ...csvData];
    setFormData((prevData) => ({
      ...prevData,
      ffscFindings: updatedFFsc,
      activity: activity,
    }));
  }, [csvData, activity]);

  useEffect(() => {
    if (auditNumber) {
      getFocusAreaFields();
      unitDetailsInfo();

    }
    setTimeout(() => getFormData(), 3000);
    // getFormData();
  }, []);

  useEffect(() => {
    let firstNumber = `${year}-${siteCode}-0001`;

    // if (formData?.areasOfConcern?.length > 0) {
    //   setFormData((prevData) => ({
    //     ...prevData,
    //     areasOfConcern: [
    //       { ...prevData.areasOfConcern[0], number: firstNumber }, // Update the first object with the new 'number'
    //       ...prevData.areasOfConcern.slice(1), // Keep the rest of the objects the same
    //     ],
    //   }));
    // }
  }, [year, siteCode]);

  useEffect(() => {
    const combineData = { ...auditPageData, ...formData };
    setAuditAndProtocolData(combineData);

    // Get audit team details from auditPageData
    let attendiesDetails = auditPageData?.audit_team || {};

    // Validate if attendiesDetails is not an empty object
    const result =
      Object.keys(attendiesDetails).length > 0
        ? Object.keys(attendiesDetails).map((key) => ({
          name: key, // Use the key as the name
          function: attendiesDetails[key],
        }))
        : []; // If it's empty, return an empty array

    // Set the result to state
    setAttendiesInArrayFormat(result);
  }, [formData, auditPageData]);

  // console.log("combine data", auditAndProtocolData);

  return (
    <>
      {loading ? (
        <Modal open={loading}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh", // Full viewport height
              width: "100%",
              flexDirection: "column",
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
              backdropFilter: "blur(5px)", // Adding a blur effect for the background
              borderRadius: "10px", // Rounded corners
              padding: "20px",
            }}
          >
            <CircularProgress color="secondary" sx={{ marginBottom: "20px" }} />
            <h3
              style={{
                color: "white",
                fontSize: "18px",
                fontWeight: "500",
              }}
            >
              Loading... Please wait
            </h3>
          </Box>
        </Modal>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              paddingBottom: "10px",
            }}
          >
            <LeadAuditOtherProtocolExcel
              auditData={auditPageData}
              protocolData={formData}
              fileName={`${unitIndex}_${auditNumber}_${new Date().getTime()}`}
              // // transformData={transformData}
              sheetNames={[
                "Unit Details",
                "Audit details",
                "Protocol details",
                "Areas of Concern",
                "PY-Areas of Concern",
                "FSSC Findings",
                "PY-FSSC Findings",
              ]}
              color="ff8200"
              // exportPosition={true}
              className="export-btn"
              auditFocusArea={auditPageData?.audit_focus_area}
              protocolFocusArea={formData?.focusArea}
              additionalAttendees={attendiesInArrayFormat}
              unitDetails={unitDetails}

            />
          </div>

          {/* Section Overview Dashboard */}
          <div className="mb-8">
            <div className="mt-4 p-4 bg-white rounded-lg shadow-sm border">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Section Overview</h3>
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
                {sectionNames.map((sectionName, index) => {
                  const stats = sectionStats[sectionName];
                  if (!stats) return null;

                  return (
                    <div key={sectionName} className="p-3 bg-gray-50 rounded-lg">
                      <div className="flex items-center justify-between mb-2">
                        <h4 className="font-medium text-gray-900 text-sm">{sectionName}</h4>
                        <div className={`w-3 h-3 rounded-full ${getHeaderColor(index).replace('bg-', 'bg-')}`}></div>
                      </div>
                      <div className="space-y-1 text-xs text-gray-600">
                        <div className={`${getProgressColor(stats.completed, stats.total)}`}>
                          Progress: {stats.completed}/{stats.total} questions
                        </div>
                        <div className={`${getProgressColor(stats.requiredCompleted, stats.required)}`}>
                          Required: {stats.requiredCompleted}/{stats.required} completed
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="accordion-component">
            {/* Dynamic Protocol Sections */}
            {formData?.protocolList?.protocolFindings?.map((section, sectionIndex) => (
              <Accordion key={sectionIndex} className="accordion-main">
                <AccordionSummary
                  sx={{ borderRadius: "10px" }}
                  className="w-full p-3 bg-gradient-to-r from-teal-500 to-teal-500 text-white font-semibold text-left flex items-center justify-between hover:from-teal-700 hover:to-teal-800 transition-all duration-20"

                  expandIcon={<ExpandMoreIcon className="arrow-white" />}
                  aria-controls={`panel${sectionIndex}-content`}
                  id={`panel${sectionIndex}-header`}
                >
                  <Typography component="span">{section.section}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="scoping-main-container py-4">
                    {/* Display Prompt if exists */}
                    {section.prompt && section.prompt.header && section.prompt.list && section.prompt.list.length > 0 && (
                      <div>
                        <div className="scoping-heading">{section.prompt.header}</div>
                        <ol style={{ paddingLeft: "0px" }}>
                          {section.prompt.list.map((item, index) => (
                            <li style={{ listStyle: "none" }} key={index}>
                              {item}
                            </li>
                          ))}
                        </ol>
                      </div>
                    )}

                    {/* Display Subsections */}
                    {section.subsection?.map((subsection, subsectionIndex) => (
                      <div key={subsectionIndex}>
                        <div className="scoping-heading">{subsection.subSectionName}:</div>
                        {subsection.questions?.map((question, questionIndex) => (
                          <div key={questionIndex} className="label-textarea">
                            <div className="label flex items-center justify-between">
                              <span>
                                {question.text}
                                {question.is_required && <span style={{ color: "#ef4444", fontSize: "24px" }} className="ml-1">*</span>}
                              </span>
                              {question.answer && question.answer.trim() && (
                                <CheckCircle2 className="w-4 h-4 text-green-500" />
                              )}
                            </div>
                            <div className="relative">
                              <textarea
                                className={`textArea ${question.answer && question.answer.trim() ? 'bg-white' : 'bg-red-50'} w-full p-3 border border-red-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 autosize-textarea `}
                                value={question.answer || ""}
                                onChange={(e) =>
                                  handleQuestionAnswerChange(sectionIndex, subsectionIndex, questionIndex, e.target.value)
                                }
                                required={question.is_required}
                              ></textarea>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </AccordionDetails>
              </Accordion>
            ))}

            {/* // Focus Areas - Special Attention  */}
            {focusAreaField.length > 0 && (
              <Accordion className="accordion-main">
                <AccordionSummary
                  sx={{ borderRadius: "10px" }}
                  className="w-full p-3 bg-gradient-to-r from-teal-500 to-teal-500 text-white font-semibold text-left flex items-center justify-between hover:from-teal-700 hover:to-teal-800 transition-all duration-20"

                  expandIcon={<ExpandMoreIcon className="arrow-white" />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <Typography component="span">
                    Focus Areas - Special Attention
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="label">
                    <b>Audit Prompt:</b> With the selected focus areas, deep
                    dive the following areas capturing not only non
                    conformities, but also evidence of compliance
                  </div>
                  <div className="scoping-heading">Key Audit Points</div>
                  {focusAreaField.length > 0 &&
                    focusAreaField.map((item, index) => (
                      <div key={item.id}>
                        <div className="label flex items-center justify-between">
                          <span>
                            {item} <span className="ml-1">*</span>
                          </span>
                          {formData.focusArea?.[item] && formData.focusArea[item].trim() && (
                            <CheckCircle2 className="w-4 h-4 text-green-500" />
                          )}
                        </div>
                        <div className="relative">
                          <textarea
                            name={item}
                            onChange={(e) =>
                              handleInputChange("focusArea", e.target.value, item)
                            }
                            value={
                              formData.focusArea ? formData.focusArea[item] : ""
                            }
                            id=""
                            className={`textArea ${formData.focusArea?.[item] && formData.focusArea[item].trim() ? 'bg-white' : 'bg-gray-50'}`}
                            required
                          ></textarea>
                        </div>
                      </div>
                    ))}
                </AccordionDetails>
              </Accordion>
            )}

            {/* // Areas of Concern- Findings Log  */}
            <Accordion className="accordion-main">
              <AccordionSummary
                sx={{ borderRadius: "10px" }}
                className="w-full p-3 bg-gradient-to-r from-teal-500 to-teal-500 text-white font-semibold text-left flex items-center justify-between hover:from-teal-700 hover:to-teal-800 transition-all duration-20"

                expandIcon={<ExpandMoreIcon className="arrow-white" />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <Typography component="span">
                  Areas of Concern- Findings Log
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {
                  formData?.areasOfConcern?.length >= 0 && (

                    <>
                      <table className="accordion-table">
                        <tr>
                          <th>Number (#)</th>
                          <th className="width-20">
                            Standard or Technical Specifications
                          </th>
                          <th>Requirement Reference</th>
                          <th>Details of Nonconformity</th>
                          <th className="width-20">Evidence of Non-conformity</th>
                          <th>Nonconformity Rating</th>
                          <th>Non-conformance Status</th>
                          <th>Action</th>
                        </tr>

                        {

                          currentYearItems.map(({ item, originalIndex }, displayIndex) => (
                            <tr key={displayIndex}>
                              <td>{item.number}</td>
                              <td>
                                <Select
                                  options={
                                    standardOptionsFormat ? standardOptionsFormat : []
                                  }
                                  placeholder="Select dropdown"
                                  name="standardOrTechnicalSpecification"
                                  value={
                                    standardOptionsFormat
                                      ? standardOptionsFormat.find(
                                        (option) =>
                                          option.value ===
                                          item.standardOrTechnicalSpecification
                                      )
                                      : ""
                                  } // Find the selected option
                                  onChange={(selectedOption) => {
                                    handleAreaOfConcernChange(
                                      originalIndex,
                                      "standardOrTechnicalSpecification",
                                      selectedOption
                                    );
                                    getRequirementReferenceOptions(
                                      selectedOption?.value,
                                      originalIndex
                                    );
                                  }}
                                />
                              </td>
                              <td>
                                <Select
                                  name="RequirementReference"
                                  options={
                                    requirementOptions[originalIndex]
                                      ? requirementOptions[originalIndex]
                                      : []
                                  }
                                  placeholder="Select dropdown"
                                  value={
                                    requirementOptions[originalIndex]
                                      ? requirementOptions[originalIndex].find(
                                        (option) =>
                                          option.value === item.RequirementReference
                                      )
                                      : ""
                                  }
                                  onChange={(selectedOption) =>
                                    handleAreaOfConcernChange(
                                      originalIndex,
                                      "RequirementReference",
                                      selectedOption
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  name="detailsOfNonconformity"
                                  placeholder="Enter text"
                                  value={item.detailsOfNonconformity}
                                  onChange={(e) =>
                                    handleAreaOfConcernChange(
                                      originalIndex,
                                      "detailsOfNonconformity",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  name="evidenceOfNonconformity"
                                  placeholder="Enter text"
                                  value={item.evidenceOfNonconformity}
                                  onChange={(e) =>
                                    handleAreaOfConcernChange(
                                      originalIndex,
                                      "evidenceOfNonconformity",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <Select
                                  options={adendumDropdown.nonconformity}
                                  placeholder="Select dropdown"
                                  name="nonconformityRating"
                                  value={adendumDropdown.nonconformity.find(
                                    (option) =>
                                      option.value === item.nonconformityRating
                                  )}
                                  onChange={(selectedOption) =>
                                    handleAreaOfConcernChange(
                                      originalIndex,
                                      "nonconformityRating",
                                      selectedOption
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <Select
                                  options={adendumDropdown.nonconformance}
                                  placeholder="Select dropdown"
                                  name="nonConformanceStatus"
                                  value={adendumDropdown.nonconformance.find(
                                    (option) =>
                                      option.value === item.nonConformanceStatus
                                  )}
                                  onChange={(selectedOption) =>
                                    handleAreaOfConcernChange(
                                      originalIndex,
                                      "nonConformanceStatus",
                                      selectedOption
                                    )
                                  }
                                />
                              </td>
                              <td>
                                {/* {index !== 0 ? ( */}
                                {/* <Button
                                onClick={() => removeAreas(index)}
                                style={{
                                  display: "grid",
                                  alignContent: "center",
                                  alignItems: "center",
                                  backgroundColor: "#f1c2b8",
                                  border: "none",
                                }}
                              >
                                <IoTrashOutline
                                  style={{ fontSize: "20px", color: "#9d3520" }}
                                />
                              </Button> */}
                                {/* )  */}
                                {/* : ( */}
                                {/* <Button
                                disabled
                                style={{
                                  display: "grid",
                                  alignContent: "center",
                                  alignItems: "center",
                                  backgroundColor: "#cdc9c9",
                                  border: "none",
                                  cursor: "not-allowed",
                                }}
                              >
                                <IoTrashOutline
                                  style={{ fontSize: "20px", color: "#3d3d3d" }}
                                />
                              </Button> */}
                                {/* )} */}

                                <Button
                                  onClick={() => removeAreas(originalIndex)}
                                  style={{
                                    display: "grid",
                                    alignContent: "center",
                                    alignItems: "center",
                                    backgroundColor: "#f1c2b8",
                                    border: "none",
                                  }}
                                >
                                  <IoTrashOutline
                                    style={{ fontSize: "20px", color: "#9d3520" }}
                                  />
                                </Button>
                              </td>
                            </tr>
                          )
                          )
                        }


                      </table>

                      <div className="another-row-container">
                        <IconButton onClick={addNewAreasOfConcern}>
                          <AddCircleIcon />
                        </IconButton>
                        <span>Add another row</span>
                      </div>



                    </>
                  )
                }

                <div style={{ color: "#0000a0", fontWeight: "bold", fontSize: "16px", margin: "20px 0px" }} >Previous Year Non-conformity</div>

                {/* previous year start from here */}
                {
                  formData?.areasOfConcern?.length >= 0 && (

                    <>
                      <table className="accordion-table">
                        <tr>
                          <th style={{
                            width: "8%", background: '#f1634d', color: "white"
                          }} >Number (#)</th>
                          <th className="width-20" style={{
                            width: "14%", background: '#f1634d', color: "white"
                          }} >
                            Standard or Technical Specifications
                          </th>
                          <th style={{
                            width: "15%", background: '#f1634d', color: "white"
                          }} >Requirement Reference</th>
                          <th style={{
                            width: "15%", background: '#f1634d', color: "white"
                          }} >Details of Nonconformity</th>
                          <th className="width-20" style={{
                            width: "15%", background: '#f1634d', color: "white"
                          }} >Evidence of Non-conformity</th>
                          <th style={{
                            width: "8%", background: '#f1634d', color: "white"
                          }} >Nonconformity Rating</th>
                          <th style={{
                            width: "5%", background: '#f1634d', color: "white"
                          }}>Non-conformance Status</th>
                          <th style={{
                            width: "20%", background: '#f1634d', color: "white"
                          }} >Corrective Action Evidence</th>
                          {/* <th>Action</th> */}
                        </tr>

                        {previousYearItems?.length > 0 ? (
                          previousYearItems.map(({ item, originalIndex }, displayIndex) => (
                            <tr key={displayIndex}>
                              <td>{item.number}</td>
                              <td>
                                <Select
                                  options={
                                    standardOptionsFormat ? standardOptionsFormat : []
                                  }
                                  placeholder="Select dropdown"
                                  name="standardOrTechnicalSpecification"
                                  value={
                                    standardOptionsFormat
                                      ? standardOptionsFormat.find(
                                        (option) =>
                                          option.value ===
                                          item.standardOrTechnicalSpecification
                                      )
                                      : ""
                                  } // Find the selected option
                                  //  onChange={(selectedOption) => {
                                  //    handleAreaOfConcernChange(
                                  //      index,
                                  //      "standardOrTechnicalSpecification",
                                  //      selectedOption
                                  //    );
                                  //    getRequirementReferenceOptions(
                                  //      selectedOption?.value,
                                  //      index
                                  //    );
                                  //  }}
                                  isDisabled
                                />
                              </td>
                              <td>
                                <Select
                                  name="RequirementReference"
                                  options={
                                    requirementOptions[originalIndex]
                                      ? requirementOptions[originalIndex]
                                      : []
                                  }
                                  placeholder="Select dropdown"
                                  value={
                                    requirementOptions[originalIndex]
                                      ? requirementOptions[originalIndex].find(
                                        (option) =>
                                          option.value === item.RequirementReference
                                      )
                                      : ""
                                  }
                                  //  onChange={(selectedOption) =>
                                  //    handleAreaOfConcernChange(
                                  //      index,
                                  //      "RequirementReference",
                                  //      selectedOption
                                  //    )
                                  //  }
                                  isDisabled
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  name="detailsOfNonconformity"
                                  placeholder="Enter text"
                                  value={item.detailsOfNonconformity}
                                  //  onChange={(e) =>
                                  //    handleAreaOfConcernChange(
                                  //      index,
                                  //      "detailsOfNonconformity",
                                  //      e.target.value
                                  //    )
                                  //  }
                                  disabled
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  name="evidenceOfNonconformity"
                                  placeholder="Enter text"
                                  value={item.evidenceOfNonconformity}
                                  //  onChange={(e) =>
                                  //    handleAreaOfConcernChange(
                                  //      index,
                                  //      "evidenceOfNonconformity",
                                  //      e.target.value
                                  //    )
                                  //  }
                                  disabled
                                />
                              </td>
                              <td>
                                <Select
                                  options={adendumDropdown.nonconformity}
                                  placeholder="Select dropdown"
                                  name="nonconformityRating"
                                  value={adendumDropdown.nonconformity.find(
                                    (option) =>
                                      option.value === item.nonconformityRating
                                  )}
                                  onChange={(selectedOption) =>
                                    handleAreaOfConcernChange(
                                      originalIndex,
                                      "nonconformityRating",
                                      selectedOption
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <Select
                                  options={adendumDropdown.nonconformance}
                                  placeholder="Select dropdown"
                                  name="nonConformanceStatus"
                                  value={adendumDropdown.nonconformance.find(
                                    (option) =>
                                      option.value === item.nonConformanceStatus
                                  )}
                                  onChange={(selectedOption) =>
                                    handleAreaOfConcernChange(
                                      originalIndex,
                                      "nonConformanceStatus",
                                      selectedOption
                                    )
                                  }
                                />
                              </td>
                              {/* <td>
                               
     
                               <Button
                                   onClick={() => removeAreas(index)}
                                   style={{
                                     display: "grid",
                                     alignContent: "center",
                                     alignItems: "center",
                                     backgroundColor: "#f1c2b8",
                                     border: "none",
                                   }}
                                 >
                                   <IoTrashOutline
                                     style={{ fontSize: "20px", color: "#9d3520" }}
                                   />
                                 </Button>
                             </td> */}
                              <td>
                                <div style={{ position: "relative", width: "100%" }}>
                                  <input
                                    type="text"
                                    name="evidenceOfCorrection"
                                    placeholder={originalIndex === 0 ? "Enter Text" : "Enter text"}
                                    value={item?.evidenceOfCorrection || ""}
                                    onChange={(e) =>
                                      handleAreaOfConcernChange(originalIndex, "evidenceOfCorrection", e.target.value)
                                    }
                                    // disabled={
                                    //   !(
                                    //     formDataCopy?.areasOfConcern[index] &&
                                    //     formDataCopy?.areasOfConcern[index].number.endsWith(".2")
                                    //   )
                                    // }
                                    style={{
                                      paddingRight: "40px", // space for the icon
                                      width: "100%",
                                      boxSizing: "border-box"
                                    }}
                                  />
                                  <OpenInFullIcon
                                    style={{
                                      position: "absolute",
                                      right: "10px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      color: "#6b7280", // gray color
                                      cursor: "pointer"


                                    }}
                                    onClick={() => {
                                      handleExpand(originalIndex, item?.evidenceOfCorrection || "")

                                    }


                                      // () => {
                                      //       if ( (
                                      //     formDataCopy?.areasOfConcern[index] &&
                                      //     formDataCopy?.areasOfConcern[index].number.endsWith(".2")
                                      //   )) {
                                      //         handleExpand(index, item?.evidenceOfCorrection || "");
                                      //       }
                                      //     }
                                    } // define this function accordingly
                                  />
                                </div>
                              </td>
                            </tr>
                          )
                          )
                        ) : (
                          <tr >
                            <td colSpan={8} style={{ padding: '1rem', color: '#6b7280', textAlign: 'center', fontWeight: "bold" }}>
                              There is no data for previous Year Non-conformity
                            </td>
                          </tr>
                        )


                        }

                      </table>
                    </>
                  )
                }
              </AccordionDetails>
            </Accordion>

            {/* // Findings from FSSC Head Office Audit */}
            <Accordion className="accordion-main">
              <AccordionSummary
                sx={{ borderRadius: "10px" }}
                className="w-full p-3 bg-gradient-to-r from-teal-500 to-teal-500 text-white font-semibold text-left flex items-center justify-between hover:from-teal-700 hover:to-teal-800 transition-all duration-20"

                expandIcon={<ExpandMoreIcon className="arrow-white" />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <Typography component="span">
                  Findings from FSSC Head Office Audit
                </Typography>
              </AccordionSummary>
              <AccordionDetails>

                {
                  formData?.ffscFindings?.length >= 0 && (
                    <>
                      <table className="accordion-table">
                        <tr className="table-header">
                          {formData?.ffscFindings.length > 0 &&
                            tableHeaderOrder.map((header, index) => (
                              <th
                                key={index}
                                className={
                                  header ===
                                    "Standard or Technical Specifications" ||
                                    header === "Details of Nonconformity"
                                    ? "width-20"
                                    : ""
                                }
                              >
                                {header === "NonConformance Status" ? "Non-Conformance Status" : header}
                              </th>
                            ))}
                        </tr>

                        {currentYearFfsc.length > 0 &&
                          currentYearFfsc.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                              {tableHeaderOrder.map((header, colIndex) => (
                                <td key={colIndex}>{row?.item?.[header]}</td>
                              ))}
                            </tr>
                          ))}

                      </table>

                      <input
                        type="file"
                        name="csvFile"
                        id="actual-file-btn"
                        onChange={uploadFileHandler}
                        hidden
                        accept=".csv"
                      />
                      <div className="file-upload-div">
                        <label
                          for="actual-file-btn"
                          className="filename-btn-container"
                        >
                          <IconButton>
                            <CloudUploadIcon />
                          </IconButton>
                          <div>
                            <span>Upload Excel File</span>
                          </div>
                        </label>
                        <div>
                          <span id="file-chosen">{fileName}</span>
                        </div>
                      </div>
                    </>
                  )


                }

                <div style={{ color: "#0000a0", fontWeight: "bold", fontSize: "16px", margin: "20px 0px" }} >Previous Year Non-conformity</div>
                {

                  formData?.ffscFindings?.length >= 0 && (
                    <>
                      <table className="accordion-table">
                        <tr className="table-header">
                          {formData?.ffscFindings.length >= 0 &&
                            previousYearTableHeaders.map((header, index) => (
                              <th
                                key={index}
                                className={
                                  header ===
                                    "Standard or Technical Specifications" ||
                                    header === "Details of Nonconformity" ||
                                    header === "Evidence Of Correction"
                                    ? "width-20"
                                    : ""
                                }
                                style={{ background: '#f1634d', color: "white", width: "20%" }}
                              >
                                {header === "NonConformance Status" ? "Non-Conformance Status" : header === 'Evidence Of Correction' ? 'Corrective Action Evidence' : header}
                              </th>
                            ))}
                        </tr>

                        {
                          previousYearFfsc?.length > 0 ? (
                            previousYearFfsc.map(({ item, originalIndex }, displayIndex) => (
                              <tr key={displayIndex}>
                                <td>{item["Number (#)"]}</td>
                                <td>{item["Standard or Technical Specifications"]}</td>
                                <td>{item["Requirement Reference"]}</td>
                                <td>{item["Details of Nonconformity"]}</td>
                                <td>{item["Evidence of Non-conformity"]}</td>
                                <td>
                                  <Select
                                    options={adendumDropdown.nonconformity}
                                    placeholder="Select dropdown"
                                    name="Nonconformity Rating"
                                    value={adendumDropdown.nonconformity.find(
                                      (option) =>
                                        option.value === item["Nonconformity Rating"]
                                    )}
                                    onChange={(selectedOption) =>
                                      handleFfscChange(
                                        originalIndex,
                                        "Nonconformity Rating",
                                        selectedOption
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <Select
                                    options={adendumDropdown.nonconformance}
                                    placeholder="Select dropdown"
                                    name="NonConformance Status"
                                    value={adendumDropdown.nonconformance.find(
                                      (option) =>
                                        option.value === item["NonConformance Status"]
                                    )}
                                    onChange={(selectedOption) =>
                                      handleFfscChange(
                                        originalIndex,
                                        "NonConformance Status",
                                        selectedOption
                                      )
                                    }
                                  />
                                </td>

                                <td>
                                  <div style={{ position: "relative", width: "100%" }}>
                                    <input
                                      type="text"
                                      name="Evidence Of Correction"
                                      placeholder={originalIndex === 0 ? "Enter Text" : "Enter text"}
                                      value={item["Evidence Of Correction"] || ""}
                                      onChange={(e) =>
                                        handleFfscChange(originalIndex, "Evidence Of Correction", e.target.value)
                                      }
                                      // disabled={
                                      //   !(
                                      //     formDataCopy?.areasOfConcern[index] &&
                                      //     formDataCopy?.areasOfConcern[index].number.endsWith(".2")
                                      //   )
                                      // }
                                      style={{
                                        paddingRight: "40px", // space for the icon
                                        width: "100%",
                                        boxSizing: "border-box"
                                      }}
                                    />
                                    <OpenInFullIcon
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        color: "#6b7280", // gray color
                                        cursor: "pointer"
                                      }}
                                      onClick={() => {
                                        handleFfscExpand(originalIndex, item["Evidence Of Correction"] || "")

                                      }


                                        // () => {
                                        //       if ( (
                                        //     formDataCopy?.areasOfConcern[index] &&
                                        //     formDataCopy?.areasOfConcern[index].number.endsWith(".2")
                                        //   )) {
                                        //         handleExpand(index, item?.evidenceOfCorrection || "");
                                        //       }
                                        //     }
                                      } // define this function accordingly
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan={8}
                                style={{
                                  padding: '1rem',
                                  color: '#6b7280',
                                  textAlign: 'center',
                                  fontWeight: 'bold',
                                }}
                              >
                                There is no data for previous year non-conformity
                              </td>
                            </tr>
                          )
                        }

                      </table>

                    </>)
                }


                <>
                  {/* <table className="accordion-table">
                    <tr className="table-header">
                      {formData?.ffscFindings.length > 0 &&
                        tableHeaderOrder.map((header, index) => (
                          <th
                            key={index}
                            className={
                              header ===
                                "Standard or Technical Specifications" ||
                              header === "Details of Nonconformity"
                                ? "width-20"
                                : ""
                            }
                          >
                            {header === "NonConformance Status" ? "Non-Conformance Status" : header}
                            </th>
                        ))}
                    </tr>
                    {formData?.ffscFindings.length > 0 &&
                      formData?.ffscFindings.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          {tableHeaderOrder.map((header, colIndex) => (
                            <td key={colIndex}>{row[header]}</td>
                          ))}
                        </tr>
                      ))}
                  </table>

                  <input
                    type="file"
                    name="csvFile"
                    id="actual-file-btn"
                    onChange={uploadFileHandler}
                    hidden
                    accept=".csv"
                  />
                  <div className="file-upload-div">
                    <label
                      for="actual-file-btn"
                      className="filename-btn-container"
                    >
                      <IconButton>
                        <CloudUploadIcon />
                      </IconButton>
                      <div>
                        <span>Upload Excel File</span>
                      </div>
                    </label>
                    <div>
                      <span id="file-chosen">{fileName}</span>
                    </div>
                  </div> */}
                </>
              </AccordionDetails>
            </Accordion>
          </div>

          {/* Progress Summary */}
          <div className="mt-8 flex justify-between items-center bg-white p-6 rounded-lg shadow-sm border">
            <div className="text-sm text-gray-600">
              <div>Progress: {getCompletedQuestionsCount()} of {totalQuestions} questions completed</div>
              {/* <div className="mt-1">
                Required fields: {Array.from(requiredQuestions).filter(id => {
                  const idStr = String(id);
                  if (idStr.startsWith('focusArea_')) {
                    const key = idStr.replace('focusArea_', '');
                    return formData?.focusArea?.[key] && formData.focusArea[key].trim().length > 0;
                  }
                  if (idStr === 'areasOfConcern_complete') {
                    const currentYearAreas = formData?.areasOfConcern?.filter(area => !area.isPreviousYear) || [];
                    return currentYearAreas.length > 0 && currentYearAreas.every(area => 
                      area.number && 
                      area.standardOrTechnicalSpecification && 
                      area.RequirementReference && 
                      area.detailsOfNonconformity && 
                      area.evidenceOfNonconformity && 
                      area.nonconformityRating && 
                      area.nonConformanceStatus
                    );
                  }
                  return false;
                }).length} of {requiredQuestions.size} completed
              </div> */}
              <div className="mt-1 text-xs">
                Sections: {sectionNames.length} total
              </div>
            </div>
          </div>

          {/* Validation Summary */}
          {!isFormValid && (
            <div className="mt-4 p-4 bg-gray-50 border border-gray-200 rounded-lg">
              <div className="flex items-center">
                <AlertCircle className="w-5 h-5 text-gray-500 mr-2" />
                <span className="text-red-700 font-medium">
                  Please complete all required(*) fields to submit the form
                </span>
              </div>
              {/* <div className="mt-2 text-sm text-gray-600">
                Missing required fields: {requiredQuestions.size - Array.from(requiredQuestions).filter(id => {
                  const idStr = String(id);
                  if (idStr.startsWith('focusArea_')) {
                    const key = idStr.replace('focusArea_', '');
                    return formData?.focusArea?.[key] && formData.focusArea[key].trim().length > 0;
                  }
                  if (idStr === 'areasOfConcern_complete') {
                    const currentYearAreas = formData?.areasOfConcern?.filter(area => !area.isPreviousYear) || [];
                    return currentYearAreas.length > 0 && currentYearAreas.every(area => 
                      area.number && 
                      area.standardOrTechnicalSpecification && 
                      area.RequirementReference && 
                      area.detailsOfNonconformity && 
                      area.evidenceOfNonconformity && 
                      area.nonconformityRating && 
                      area.nonConformanceStatus
                    );
                  }
                  return false;
                }).length}
              </div> */}
            </div>
          )}

          <div className="bottom-container">
            <div className="required-text">
              Fields marked <span>*</span> are Required.
            </div>
            <div id="action-button-container">
              {actionLoading.save ? (
                <button disabled className="action-btn">
                  Loading...
                </button>
              ) : (
                <button
                  onClick={() => submitGapAssesmentForm("saved")}
                  className="action-btn"
                >
                  Save
                </button>
              )}
              {actionLoading.submit ? (
                <button className="action-btn" disabled>
                  Loading...
                </button>
              ) : (
                <button
                  className="action-btn"
                  onClick={() => {
                    // setOpenPopup(true);
                    submitGapAssesmentForm("completed")
                  }}
                  disabled={!isFormValid}
                >
                  Next
                </button>
              )}
            </div>
            <Dialog
              open={openPopup}
              onClose={() => {
                setOpenPopup(false);
              }}
              id="mars-super-admin-popup"
            >
              <DialogContent>
                <div className="popup-text-container">
                  <p>
                    Once you click 'Next,' your data will be locked and cannot
                    be modified or edited. Are you sure you want to proceed?
                  </p>
                </div>
              </DialogContent>
              <DialogActions
                style={{
                  padding: "24px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "40px",
                }}
              >
                <button
                  className="logout-popup-btn primary-btn mars-admin-popup"
                  d
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    submitGapAssesmentForm("completed");
                    setOpenPopup(false);
                  }}
                >
                  Yes
                </button>
                <button
                  className="logout-popup-btn secondary-btn mars-admin-popup"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setOpenPopup(false);
                  }}
                >
                  No
                </button>
              </DialogActions>
            </Dialog>
          </div>
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={open}
            onClose={handleClose}
            message={snackbarMessage}
            autoHideDuration={2000}
            className="success-snackbar"
          />
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={errorSnackbarOpen}
            onClose={handleErrorClose}
            message={errorSnackbarMessage}
            autoHideDuration={5000}
            className="error-snackbar"
            sx={{
              '& .MuiSnackbarContent-root': {
                backgroundColor: '#f44336',
                color: 'white',
                fontWeight: 'bold'
              }
            }}
          />
        </>
      )}

      {error && (
        <Box
          sx={{
            position: "fixed",
            top: 55,
            right: 16,
            zIndex: 1300, // Ensures it appears above other content
          }}
        >
          <Alert
            severity="error"
            sx={{
              fontSize: "20px",
              width: "auto",
            }}
          >
            Something went wrong! Please try again later.
          </Alert>
        </Box>
      )}

      <Dialog
        open={openExpand}
        onClose={handleExpandClose}
        PaperProps={{
          style: {
            width: "600px",
            height: "400px"
          }
        }}
      >
        <DialogTitle>Edit Evidence of Correction</DialogTitle>
        <DialogContent style={{ flexGrow: 1 }}>
          <TextField
            fullWidth
            multiline
            minRows={10}
            value={lastValue}
            onChange={(e) => {
              const newValue = e.target.value;
              setLastValue(newValue);
              // Remove the immediate save - only update the temporary state
            }}
            variant="outlined"
            style={{ marginTop: "10px" }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} sx={{
            color: "#0000a0"
          }}>
            Cancel
          </Button>
          <Button onClick={handleSave} variant="contained" sx={{
            backgroundColor: "#0000a0"
          }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openFFscExpand}
        onClose={handleExpandClose}
        PaperProps={{
          style: {
            width: "600px",
            height: "400px"
          }
        }}
      >
        <DialogTitle>Edit FSSC Details</DialogTitle>
        <DialogContent style={{ flexGrow: 1 }}>
          <TextField
            fullWidth
            multiline
            minRows={10}
            value={lastValue}
            onChange={(e) => {
              const newValue = e.target.value;
              setLastValue(newValue);
              // Remove the immediate save - only update the temporary state
            }}
            variant="outlined"
            style={{ marginTop: "10px" }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} sx={{
            color: "#0000a0"
          }}>
            Cancel
          </Button>
          <Button onClick={handleSave} variant="contained" sx={{
            backgroundColor: "#0000a0"
          }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default GapAssesmentAccordion;
